import Spinner from '../Spinner'

export default function GraphHeader({
  leftSection,
  rightSection,
}: {
  leftSection: { title: string; count: number | undefined | null }[]
  rightSection: React.ReactElement[]
}) {
  return (
    // Stack on mobile so the control cluster drops below the titles instead of
    // running off the right edge; row layout with the fixed height returns at md.
    // mb-5 gives the chart/trend content below some breathing room from the
    // controls on mobile (desktop's fixed h-16 already spaces it).
    <div className="mb-5 flex flex-col gap-4 md:mb-0 md:h-16 md:flex-row md:items-start md:justify-between">
      <div>
        <div className="flex space-x-9">
          {leftSection?.map((section, i) => (
            <div key={section.title}>
              <div className="text-heading-sm text-strong">{section.title}</div>
              {section.count !== null && (
                <div className="mt-2 text-heading-lg text-strong">
                  {typeof section.count === `undefined` ? <Spinner size={8} /> : section.count.toLocaleString(`en-US`)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {/* Controls wrap onto their own lines on mobile (each segmented control is
          a label + buttons); single spaced row from md up. */}
      <div className="flex flex-wrap items-center gap-3 md:flex-nowrap md:gap-0 md:space-x-6">
        {rightSection?.map((section, i) => section)}
      </div>
    </div>
  )
}
